export const minLength = (value: string): boolean => value.length >= 8;

export const minLowercase = (value: string): boolean => /[a-z]/g.test(value);

export const minUppercase = (value: string): boolean => /[A-Z]/g.test(value);

export const minNumbers = (value: string): boolean => /[0-9]/g.test(value);

export const minSymbols = (value: string): boolean => /[^a-zA-Z0-9\s]/g.test(value);
